import React, {
  useImperativeHandle,
  useState,
  forwardRef,
  useRef,
  ForwardRefRenderFunction,
  ForwardRefExoticComponent,
  PropsWithoutRef,
  RefAttributes,
} from 'react';
import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { buildQaId } from 'utils/build-qa-id';
import { CslProtocolFormModalStyles } from './styles';
import { QA_ID } from './constants';
import { CslModalInnerForm, IProps } from './inner-form';

export type ICslProtocolFormModalProps = IProps

export interface ICslProtocolFormModalRef {
  setOpen(value: boolean): void;
}

const useStyles = makeStyles(CslProtocolFormModalStyles);

const qaIdBuilder = buildQaId(QA_ID);
const CslProtocolFormModalCls: ForwardRefRenderFunction<
  ICslProtocolFormModalRef,
  ICslProtocolFormModalProps
> = (props, ref) => {
  const classes = useStyles();

  const { onSuccess, onCancel, editMode, ...otherProps } = props;

  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    setOpen,
  }));

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseWrapper = (handler?: () => void) => {
    return () => {
      handleClose();
      if (handler) {
        handler();
      }
    };
  };

  return (
    <Dialog
      open={open}
      fullWidth
      onClose={handleClose}
      data-qa-id={qaIdBuilder('root')}
      maxWidth="md"
    >
      <DialogTitle className={classes.titleWrp}>
        <Typography variant="h6" className={classes.title}>
          {editMode ? 'Edit' : 'Add'} CSL Assessment / Plan
        </Typography>
      </DialogTitle>
      <CslModalInnerForm
        editMode={editMode}
        onSuccess={handleCloseWrapper(onSuccess)}
        onCancel={handleCloseWrapper(onCancel)}
        {...otherProps}
      />
    </Dialog>
  );
};

export const CslProtocolFormModal = forwardRef(CslProtocolFormModalCls);
